var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.55555556,5.25 C8.7702557,5.25 8.95355827,5.32324146 9.10546875,5.46972656 C9.25737923,5.61621167 9.33333333,5.79296771 9.33333333,6 L9.33333333,11.25 C9.33333333,11.4570323 9.25737923,11.6337883 9.10546875,11.7802734 C8.95355827,11.9267585 8.7702557,12 8.55555556,12 L0.777777778,12 C0.56307763,12 0.379775065,11.9267585 0.227864583,11.7802734 C0.0759541016,11.6337883 0,11.4570323 0,11.25 L0,6 C0,5.79296771 0.0759541016,5.61621167 0.227864583,5.46972656 C0.379775065,5.32324146 0.56307763,5.25 0.777777778,5.25 L1.55555556,5.25 L1.55555556,3 C1.55555556,2.59374797 1.63758599,2.20605653 1.80164931,1.83691406 C1.96571263,1.46777159 2.1874986,1.14843885 2.46701389,0.87890625 C2.74652918,0.609373652 3.07768906,0.395508604 3.46050347,0.237304688 C3.84331789,0.0791007715 4.24536826,0 4.66666667,0 C5.08796507,0 5.49001545,0.0791007715 5.87282986,0.237304688 C6.25564428,0.395508604 6.58680416,0.609373652 6.86631944,0.87890625 C7.14583473,1.14843885 7.36762071,1.46777159 7.53168403,1.83691406 C7.69574735,2.20605653 7.77777778,2.59374797 7.77777778,3 L7.77777778,5.25 L8.55555556,5.25 Z M3.11111101,3 L3.11111101,5.25 L6.22222201,5.25 L6.22222201,3 C6.22222201,2.58593543 6.07031381,2.23242334 5.76649286,1.93945312 C5.46267191,1.64648291 5.09606679,1.5 4.66666651,1.5 C4.23726623,1.5 3.87066111,1.64648291 3.56684016,1.93945312 C3.2630192,2.23242334 3.11111101,2.58593543 3.11111101,3 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "18-admin-settings",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "18.5.4-UCAP-AdvisorCenter-Admin-Settings-Integrations-Synced",
    transform: "translate(-341.000000, -379.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content",
    transform: "translate(240.000000, 72.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sidemenu",
    transform: "translate(0.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu"
  }, /*#__PURE__*/React.createElement("g", {
    id: 4,
    transform: "translate(0.000000, 241.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content",
    transform: "translate(16.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.-Icons/General/lock",
    transform: "translate(85.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(3.333333, 2.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "ic_lock",
    fill: "#222426",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFA8-Color",
    mask: "url(#mask-2)",
    fill: "#8A8888"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.333333, -2.000000)",
    id: "color"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }))))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLock);
export default __webpack_public_path__ + "static/media/ic_lock.523d68abe0ac04c0866517b255db79d2.svg";
export { ForwardRef as ReactComponent };